module.exports = __webpack_public_path__ + "media/images/pen_lightyellow-63ddad2e.png";